import { DataModel } from "@toolpad/core/Crud";

import { IBackofficeUserDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";
import { DropdownOdata } from "../components/DropdownOdata";

type UserDtoDataModel = IBackofficeUserDto & DataModel;

export default function UsersPage() {
  const columns: MagicCrudFields<IBackofficeUserDto>[] = [
    {
      field: nameof<IBackofficeUserDto>("id"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IBackofficeUserDto>("name"),
      type: "string",
      editable: false,
    },
    {
      field: nameof<IBackofficeUserDto>("lastName"),
      type: "string",
      editable: false,
    },
    {
      field: nameof<IBackofficeUserDto>("email"),
      type: "string",
    },
    {
      field: nameof<IBackofficeUserDto>("role"),
      type: "string",
      editable: false,
    },
    {
      field: "roleId",
      type: "string",
      notInGridMode: true,
      renderFormField: ({ value, onChange, error }) => (
        <DropdownOdata
          url="roles"
          fieldNameId="id"
          fieldNameDescription="displayName"
          value={value?.toString()}
          onChange={onChange}
          error={error}
          label="role"
        />
      ),
    },
    {
      field: nameof<IBackofficeUserDto>("updateDate"),
      type: "dateTime",
      editable: false,
    },
  ];

  return (
    <MagicCrud<UserDtoDataModel>
      name="backofficeUser"
      apiUrl="users"
      columns={columns}
      appUrl="/users"
      customCreateUrl="users/invite"
      customCreateLabel="inviteUser"
      disable={{
        show: true,
      }}
    />
  );
}
